// removed by extract-text-webpack-plugin
module.exports = {"Row":"ProjectListItem__Row--3Uq9f","Votes":"ProjectListItem__Votes--1Gfod","Rank":"ProjectListItem__Rank--1f0m9","Title":"ProjectListItem__Title--3Z7TL","Subtitle":"ProjectListItem__Subtitle--2mouo","Link":"ProjectListItem__Link--1cm_d"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProjectList/ProjectListItem/ProjectListItem.scss
// module id = 412
// module chunks = 0